import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import useStyles from './aor-run-detail.styles';

/**
 * One staff-user row of an apply report: the P7 branch's `details` (#33093).
 *
 * No link column — a staff user has no detail page in staff-fe, and the login id is what the
 * operator searches the staff-users dashboard by.
 *
 * The last two columns are SUGGESTIONS, not applied changes. P7 never writes a username or a write
 * affinity: doing so means deleting and re-creating the Descope user (Cognito usernames are
 * immutable), which also emails the agent. The operator pastes these into Change Staff Username
 * (Bulk) — so an unsplittable username shows a blank suggestion rather than a guess.
 */
const StaffUserResultRow = ({ details, error, showError }) => {
  const classes = useStyles();
  const suggestedUsername = details.usernameSuggestion === 'ambiguous' ? 'needs review' : details.suggestedNewUsername;

  return (
    <TableRow>
      <TableCell>{details.loginId || '—'}</TableCell>
      <TableCell>{details.side || '—'}</TableCell>
      <TableCell>{details.previousStems || '—'}</TableCell>
      <TableCell>{details.addedStems || '—'}</TableCell>
      <TableCell>{details.outcome ?? '—'}</TableCell>
      <TableCell>{details.suggestedNewAffinity || '—'}</TableCell>
      <TableCell>{suggestedUsername || '—'}</TableCell>
      {showError && <TableCell className={classes.errorCell}>{error ?? '—'}</TableCell>}
    </TableRow>
  );
};

StaffUserResultRow.propTypes = {
  details: PropTypes.object.isRequired,
  error: PropTypes.string,
  showError: PropTypes.bool
};

StaffUserResultRow.defaultProps = {
  error: null,
  showError: false
};

export const staffUserResultVariant = {
  key: 'staffUsers',
  label: 'staff users',
  columns: ['Login', 'Side', 'Stems before', 'Stems added', 'Outcome', 'Suggested affinity', 'Suggested username'],
  rowKey: (details) => details.loginId,
  // Key presence, not truthiness: a worker that failed before it could read the record still emits
  // `loginId: ''`, and that row must reach this table rather than the policy fallback.
  matches: (details) => 'loginId' in details,
  Row: StaffUserResultRow
};

export default StaffUserResultRow;
